export default __webpack_public_path__ + "static/media/Vambraces of the Masquer of the Sands.32cff3b7.jpg";